<div class="user-not-found">
  <p>¡Ups! No pudimos encontrar tus datos, nos puedes ayudar a ingresarlos:</p>
  <button class="btn">Continuar</button>
</div>
